// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__gPDiR","complete":"Label_complete__1Me0R"};